// extracted by mini-css-extract-plugin
export var content = "hero-module--content--u1cO9";
export var details = "hero-module--details--WWO7r";
export var hero = "hero-module--hero--JreNK";
export var image = "hero-module--image--wE2lP";
export var title = "hero-module--title--+uEef";